import React from "react";


const TMrecommendations = () => {
  document.title = "tm-recommendations";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>tm-recommendations</h1>
        
      </div>
    </React.Fragment>
  );
};

export default TMrecommendations;
